/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type settlingin_BillingPreviewResponse = {
    amount?: number;
    /**
     * BillingMode is deliberately NOT an `enums:` field. The service emits the plan's
     * raw mode verbatim, including empty or unrecognised values paired with a
     * PreviewState of `mode_unknown`; a closed enum in the generated client cannot
     * represent those and would mistype a legitimate 200 response.
     */
    billing_mode?: string;
    currency?: string;
    description?: string;
    /**
     * FirstBillingDate is the first billing day F (#1697, "YYYY-MM-DD") of a closed
     * plan in its group's initial phase. Explicit null while the plan is open and
     * for a group that already pays (no F clamp).
     */
    first_billing_date?: string | null;
    /**
     * FirstInvoicePeriod is the "YYYY-MM" period whose invoice carries the
     * settling-in fee: the period containing F in the initial phase, the sign-off
     * period for a group that already pays. Explicit null while the plan is open.
     */
    first_invoice_period?: string | null;
    /**
     * InvoicesHeld is true while the plan is open and the group's invoices are
     * held (a new contract in its initial phase, #1697).
     */
    invoices_held?: boolean;
    preview_state?: settlingin_BillingPreviewResponse.preview_state;
    quantity?: number;
    /**
     * SettlingInFeeApplies is false when the contract is subsidised (#1703): its
     * settling-in days are billed as regular care, so no settling-in fee line is
     * billed, whatever the billing mode, and preview_state is no_charge.
     */
    settling_in_fee_applies?: boolean;
    target_period?: string;
    unit_rate?: number;
    week_factor?: number;
};
export namespace settlingin_BillingPreviewResponse {
    export enum preview_state {
        COMPUTED = 'computed',
        NO_CHARGE = 'no_charge',
        ZERO_NOT_BILLED = 'zero_not_billed',
        AMOUNT_MISSING = 'amount_missing',
        MODE_UNKNOWN = 'mode_unknown',
    }
}

